<template>
  <nav>
   
  
  </nav>
  <router-view/>
</template>

<style lang="scss">


body,html
{
    background: linear-gradient(to right,#110800,rgb(243, 110, 21));
    -webkit-background: linear-gradient(to right,#000000,rgb(226, 97, 11));
    -moz-background: linear-gradient(to right,#5c4938,rgb(210, 108, 40));
}

</style>
